import React from 'react';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { servicedeskItsmSampleSpaceRoute } from '@atlassian/jira-router-routes-servicedesk-itsm-sample-space-routes/src/servicedeskItsmSampleSpaceRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import {
	APP_NAMES,
	toPackageName,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import type ServiceDeskItsmSampleSpaceType from '@atlassian/jira-spa-apps-servicedesk-itsm-sample-space/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyItsmSampleSpace = lazyForPaint<typeof ServiceDeskItsmSampleSpaceType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-itsm-sample-space", jiraSpaEntry: "async-servicedesk-itsm-sample-space" */ '@atlassian/jira-spa-apps-servicedesk-itsm-sample-space'
		),
);

const ItsmSampleSpace = () => (
	<LazyPage
		Page={LazyItsmSampleSpace}
		pageId="spa-apps/servicedesk/itsm-sample-space"
		shouldShowSpinner
	/>
);

export const servicedeskItsmSampleSpaceRouteEntry = createEntry(
	servicedeskItsmSampleSpaceRoute,
	() => ({
		group: 'servicedesk',
		isRedirect: true,
		component: ItsmSampleSpace,
		layout: serviceProjectLayout,
		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticSidebarShortcutsResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
		],
		forPaint: [LazyAtlassianNavigation, LazyItsmSampleSpace],
		perfMetricKey: 'jsm-sample-space-landing-page',

		meta: {
			reporting: {
				id: APP_NAMES.ITSM_SAMPLE_SPACE,
				packageName: toPackageName(APP_NAMES.ITSM_SAMPLE_SPACE),
				teamName: 'itops-mithril',
			},
		},
	}),
);
